// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag-wrapper{height:70px;display:grid;grid-template-columns:1fr auto}.tag-explore{justify-self:right;align-self:center}.tag-info{padding-top:0;padding-bottom:0;display:flex;align-items:center}.loading-spinner{margin-left:5px}.error-message{margin:0 0 0 15px;color:#e9573f;font-size:.8em}.name-input{width:300px}", ""]);
// Exports
module.exports = exports;
